module.exports = __webpack_public_path__ + "infocentrum6.jpg?d8345d17b7d02fd15dc75c4fcd26b73a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum6.jpg
// module id = 258
// module chunks = 0